define.alias("ember-math-helpers/helpers/cosh", "auth/helpers/cosh");